module.exports = __webpack_public_path__ + "static/img/linian.37a495cd.png";